import { observable } from 'mobx'
import { ISODocumentRequest } from '../../requests/ISODocumentRequest'
import fileStore from '../../stores/fileStore'

class ISODocumentStore {
  @observable items = []
  @observable breadCrumb = []
  @observable currentFolderId = 'root'
  @observable isLoading = false

  @observable sortInfo = {
    sortedInfo: null,
  }

  @observable keyword = null

  getItems = async () => {
    try {
      this.isLoading = true

      const response = await ISODocumentRequest.getFolderDetails(
        this.currentFolderId
      )
      this.items = response.data.data
      this.breadCrumb = response.data.breadCrumb
    } finally {
      this.isLoading = false
    }
  }

  search = async () => {
    try {
      this.isLoading = true

      const response = await ISODocumentRequest.search(
        this.currentFolderId,
        this.keyword
      )
      this.items = response.data.data
      this.breadCrumb = []
    } finally {
      this.isLoading = false
    }
  }

  delete = async id => {
    try {
      this.isLoading = true

      await fileStore.deleteCloudObject(id)

      await this.getItems()
    } finally {
      this.isLoading = false
    }
  }

  clear = () => {
    console.log('ISODocumentStore. clear')
    this.items = []
    this.breadCrumb = []
    this.currentFolderId = 'root'
    this.isLoading = false
  }
}

export default new ISODocumentStore()
